import styled from 'styled-components';
export const Row = styled.div `
  background-color: #fff;

  flex-direction: row;
  flex-wrap: ${({ nowrap }) => (nowrap ? 'nowrap' : 'wrap')};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
`;
